var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCircleInfoGradient = function SvgIcCircleInfoGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M8 14.333A6.333 6.333 0 1 0 8 1.667a6.333 6.333 0 0 0 0 12.666m.667-7.122c0-.349-.299-.632-.667-.632s-.667.283-.667.632v4.737c0 .35.299.631.667.631s.667-.282.667-.63zM9 5.001a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.763,
    x2: 22.669,
    y1: 4.481,
    y2: 10.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0089FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F28B7"
  })))));
};
export default SvgIcCircleInfoGradient;